import { useEffect, useState } from "react";

import { AI_DASHBOARDS_VIDEO_CARD_DISMISSED_KEY } from "./dashboardHelpVideo";

const DISMISS_CHANGED_EVENT = "aiDashboardsVideoPromoDismissChanged";

function readDismissed(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.localStorage.getItem(AI_DASHBOARDS_VIDEO_CARD_DISMISSED_KEY) === "true";
}

/** Whether the user dismissed the AI Dashboards video promo (sidebar + help menu stay in sync). */
export function useAiDashboardsVideoPromoDismissed(): boolean {
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    setDismissed(readDismissed());
    const handler = () => setDismissed(readDismissed());
    window.addEventListener("storage", handler);
    window.addEventListener(DISMISS_CHANGED_EVENT, handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener(DISMISS_CHANGED_EVENT, handler);
    };
  }, []);

  return dismissed;
}

export function dismissAiDashboardsVideoPromo(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(AI_DASHBOARDS_VIDEO_CARD_DISMISSED_KEY, "true");
  window.dispatchEvent(new Event(DISMISS_CHANGED_EVENT));
}
